import {createStyles, Theme} from '@material-ui/core';
import {FONT_FAMILY} from 'src/main.style';

export const ChildInfoVaccinationsStyle = (theme: Theme) => createStyles({
  paper: {
    width: 'calc(100% - 24px)',
    maxWidth: '600px',
    maxHeight: 'calc(100% - 24px)',
    margin: '12px',
    borderRadius: '18px',
    backgroundColor: theme.palette.background.default,
  },
  content: {
    minWidth: 0,
    padding: '2px',
  },
  footer: {
    flexShrink: 0,
    borderTop: `1px solid ${theme.palette.divider}`,
    paddingTop: '12px',
  },
  cards: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    minWidth: 0,
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: '18px',
    minWidth: 0,
    padding: '18px',
    borderRadius: '14px',
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
  },
  fields: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
    gap: '16px',
    '@media (max-width: 479px)': {
      gridTemplateColumns: 'minmax(0, 1fr)',
    },
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
    gap: '7px',
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: '12px',
    lineHeight: '18px',
    fontWeight: 500,
  },
  input: {
    width: '100%',
    minWidth: 0,
    height: '48px',
    boxSizing: 'border-box',
    padding: '10px 12px',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '8px',
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    fontFamily: FONT_FAMILY,
    fontSize: '16px',
    lineHeight: '24px',
    '&:focus': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: '1px',
    },
    '&[aria-invalid="true"]': {borderColor: theme.palette.error.main},
  },
  dateButton: {
    minHeight: '48px',
    minWidth: 0,
    padding: '10px 12px',
    borderRadius: '8px',
    borderColor: theme.palette.divider,
    textTransform: 'none',
    letterSpacing: 'normal',
    fontSize: '16px',
    '& .MuiButton-label': {justifyContent: 'flex-start'},
  },
  dateActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    gap: '4px',
    padding: '8px',
    '& button': {minHeight: '44px'},
  },
  nameInput: {fontWeight: 500},
  stepper: {
    display: 'flex',
    alignItems: 'center',
    height: '48px',
    boxSizing: 'border-box',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '8px',
    '&:focus-within': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: '1px',
    },
  },
  doseInput: {
    flex: 1,
    minWidth: 0,
    width: '100%',
    height: '44px',
    border: 0,
    outline: 0,
    background: 'transparent',
    color: theme.palette.text.primary,
    fontFamily: FONT_FAMILY,
    fontSize: '18px',
    fontWeight: 500,
    textAlign: 'center',
    MozAppearance: 'textfield',
    '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {WebkitAppearance: 'none', margin: 0},
  },
  stepButton: {
    width: '44px',
    height: '44px',
    flexShrink: 0,
    color: theme.palette.type === 'dark' ? theme.palette.primary.light : theme.palette.primary.main,
  },
  removeButton: {
    width: '44px',
    height: '44px',
    flexShrink: 0,
    marginTop: '27px',
    color: theme.palette.text.secondary,
  },
  action: {
    minHeight: '44px',
  },
  addButton: {
    minHeight: '48px',
  },
  empty: {
    margin: 0,
    padding: '30px 16px',
    color: theme.palette.text.secondary,
    fontSize: '14px',
    lineHeight: '22px',
    textAlign: 'center',
  },
  removed: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '8px',
    color: theme.palette.text.secondary,
    fontSize: '13px',
  },
  error: {
    color: theme.palette.error.main,
    fontSize: '12px',
    lineHeight: '18px',
  },
});



// WEBPACK FOOTER //
// ./src/components/childinfo/ChildInfoVaccinations.style.ts